<script setup lang="ts">
import { faArrowDownToBracket } from '@fortawesome/pro-light-svg-icons'

defineProps<{
  disabled?: boolean
  layout?: 'reading' | 'list'
}>()

defineEmits<{
  (e: 'click'): void
}>()
</script>

<template>
  <!-- aria-disabled instead of disabled keeps the button focusable, so keyboard and screen-reader users reach the tooltip that says why -->
  <button
    id="open-download-modal-btn"
    class="no-underline !w-fit"
    :class="[
      buttonVariants.favorite.base({ intent: 'filled', layout }),
      disabled && 'opacity-50 cursor-not-allowed',
    ]"
    aria-label="Åpne nedlastingsvindu"
    :aria-disabled="disabled || undefined"
    @click="!disabled && $emit('click')"
  >
    <Icon :icon="faArrowDownToBracket" />
    <span class="font-medium text-sm hidden nav:block">Last ned</span>
  </button>
</template>
